import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import FlagStore from '../FlagStore';
import InputStore from '../InputStore';
import { ContentFilteringStore } from './ContentFilteringStore';
import { DataLossPreventionStore } from './DLPStore';
import SecurityOptionsStore from './SecurityOptionsStore';
import UISettingsStore from './UISettingsStore';

export default class BrowserPolicyEditStore {
    static PropType = PropTypes.shape({
        isNew: PropTypes.bool.isRequired,
        modal: FlagStore.PropType.isRequired,
        exitConfirmationModal: FlagStore.PropType.isRequired,
        id: PropTypes.number,
        name: PropTypes.string.isRequired,
        isDefault: PropTypes.bool.isRequired,
        nameStore: InputStore.PropType.isRequired,
        uiSettings: UISettingsStore.PropType.isRequired,
        securityOptions: SecurityOptionsStore.PropType.isRequired,
        dlp: DataLossPreventionStore.PropType.isRequired,
        contentFiltering: ContentFilteringStore.PropType.isRequired,
        hasChanged: PropTypes.func.isRequired,
        isValid: PropTypes.bool.isRequired,
        closeDeleteModal: PropTypes.func.isRequired,
        viewMode: PropTypes.bool.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class BrowserPolicyEditStore */{
            isNew: false,
            modal: new FlagStore(false),
            deleteModal: new FlagStore(false),
            deleteConfirmation: new FlagStore(false),
            allIsolatedCategories: [],
            exitConfirmationModal: new FlagStore(false),
            id: null,
            isDefault: false,
            name: '',
            viewMode: false,
            nameStore: new InputStore({ value: '' }),
            uiSettings: new UISettingsStore(),
            securityOptions: new SecurityOptionsStore(),
            dlp: new DataLossPreventionStore(),
            contentFiltering: new ContentFilteringStore(),
            get isValid() {
                return this.nameStore.isValid && this.dlp.isValid &&
                    this.contentFiltering.urlFilterStore.allowedUrl
                        .urlBulkEditorStore.bulkEditorStore.isValid() &&
                this.contentFiltering.urlFilterStore.blockedUrl.urlBulkEditorStore.bulkEditorStore.isValid();
            },
        }, data);

        this.nameStore.setValidator(() => !!this.nameStore.value);
    }

    hasChanged = () => (this.nameStore.value !== this.name
        || this.uiSettings.hasChanged
        || this.securityOptions.hasChanged
        || this.dlp.hasChanged
        || this.contentFiltering.hasChanged());


    setMetadata = action((categories) => {
        this.allIsolatedCategories.replace(categories || []);
    });

    setValue = action((data = {}) => {
        this.id = data.id;
        this.isNew = !data.id;
        this.isDefault = data.isDefault;

        this.name = data.name;
        this.nameStore.setValue(data.name);
        this.nameStore.setTouched(true);

        this.uiSettings.setFromObject(data);
        this.securityOptions.setFromObject(data);
        this.dlp.setFromObject(data.dataLossPrevention || {});
        this.contentFiltering.setFromObject({
            ...data.contentFiltering,
            allCategories: [...this.allIsolatedCategories],
        });
    });

    closeDeleteModal = action(() => {
        this.deleteModal.close();
        this.deleteConfirmation.setFalse();
    });

    value = () => ({
        id: this.id,
        name: this.nameStore.value,
        isDefault: this.isDefault,
        ...this.uiSettings.toObject(),
        ...this.securityOptions.toObject(),
        dataLossPrevention: this.dlp.toObject(),
        contentFiltering: this.contentFiltering.toObject(),
    });
}
